import { AUTH_TOKEN_KEY } from "config/constants";

export default function tokenExists() {
	return (
		sessionStorage.getItem(AUTH_TOKEN_KEY) !== null ??
		localStorage.getItem(AUTH_TOKEN_KEY) !== null
	);
}
